module.exports = __webpack_public_path__ + "img/modulo_Social.b212d0f.svg";